import { makeStyles } from '@material-ui/core/styles'

const useStyles = makeStyles((theme) => ({
  root: {
    color: theme.palette.secondary.main,
    /**
     * Do not use overflow-x hidden here — it creates a scroll
     * container and clips `position: sticky` on the booking card.
     * Nested About bands no longer full-bleed, so the row does not
     * need this clip.
     */
    overflow: 'visible',
  },
  rootWithStickyCtaBar: {
    paddingBottom: theme.spacing(14),
    [theme.breakpoints.up('md')]: {
      paddingBottom: 0,
    },
  },
}))

export default useStyles
